import { Container } from 'react-bootstrap-five'
import Helmet from 'react-helmet'

import { buildTranslate } from 'locales'

import { Text } from '@thanx/uikit/text'
import { useStyletron } from '@thanx/uikit/theme'
import Content from 'scenes/Locations/Landing/Content'

const t = buildTranslate('locations.location_list')

const Landing = () => {
  const [css] = useStyletron()

  return (
    <div className="w-100 h-100 pt-m pb-xxl px-0 white-bkg border-bottom-1 grey-20-border">
      <Container className="pt-m pb-xl">
        <div className="d-flex justify-content-between">
          <Text.Header2 className="m-0 mr-xl">{t('title')}</Text.Header2>
        </div>
      </Container>
      <Helmet>
        <title>{t('page_title')}</title>
      </Helmet>
      <div
        className={`grey-05-bkg border-top-1 pb-xxl grey-20-border pt-xl ${css({
          minHeight: 'calc(100% - 75px)',
        })}`}
      >
        <Container>
          <Content />
        </Container>
      </div>
    </div>
  )
}

export default Landing
